import { SvgIcon, useTheme } from "@mui/material";

const OfficeIcon = ({ color, fontSize }) => {

    const theme = useTheme();

    return (
        <SvgIcon sx={{ fontSize: fontSize || 32, mt: .3, mx: 1 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <g clipPath="url(#clip0_565_21862)">
                    <path d="M28 2H16C15.4697 2.00053 14.9613 2.21141 14.5864 2.58637C14.2114 2.96133 14.0005 3.46973 14 4V14H4C3.46973 14.0005 2.96133 14.2114 2.58637 14.5864C2.21141 14.9613 2.00053 15.4697 2 16V30H30V4C29.9994 3.46975 29.7885 2.9614 29.4135 2.58646C29.0386 2.21152 28.5302 2.00061 28 2ZM9 28V21H13V28H9ZM28 28H15V20C15 19.7348 14.8946 19.4804 14.7071 19.2929C14.5196 19.1054 14.2652 19 14 19H8C7.73478 19 7.48043 19.1054 7.29289 19.2929C7.10536 19.4804 7 19.7348 7 20V28H4V16H16V4H28V28Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M20 8H18V10H20V8Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M26 8H24V10H26V8Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M20 14H18V16H20V14Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M26 14H24V16H26V14Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M20 19.9996H18V21.9996H20V19.9996Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M26 19.9996H24V21.9996H26V19.9996Z" fill={color || theme.palette.secondary.contrastText} />
                </g>
                <defs>
                    <clipPath id="clip0_565_21862">
                        <rect width="32" height="32" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    );

};

export default OfficeIcon;